import React from "react";
import "./Navbar2.css";
import { useNavigate } from "react-router-dom";
import logoRoadAssist from "../images/logo_road-assist.svg";

export const Navbar2 = () => {
    const navigate = useNavigate();

    const goToProfile = () => {
        navigate("/profile-page");
    };

    const goToHome = () => {
        navigate("/");
    };

    return (
        <div className="navbar2-container">
            <img
                className="logo"
                alt="Logo"
                src={logoRoadAssist}
                onClick={goToHome}
                style={{ cursor: "pointer" }}
            />

            <div className="info-section">
                <div className="text-wrapper-28">+998 55 515-65-65</div>
                <div className="FLAG">
                    <div className="rectangle-4" />
                    <div className="rectangle-5" />
                    <div className="rectangle-6" />
                </div>
                <div className="text-wrapper-29">RU</div>

                <div
                    className="text-wrapper-30"
                    onClick={goToProfile}
                >
                    ЛИЧНЫЙ КАБИНЕТ
                </div>
            </div>
        </div>
    );
};
